//Node imports
import { dispatcher, ingenuity } from "@quest/base-core";
import { FreeGameState } from "@quest/murka-games-behavior-leopard/dist/";
import { TopLogoControllerFg } from "@quest/murka-games-behavior-leopard/dist/Game/TopLogo/TopLogoControllerFg";
import { SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist/";

//Class imports
import { View } from "../FreeGame/View";
import { DisplayObject } from "pixi.js-legacy";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { RetriggerViewGame } from "../Retrigger/RetriggerViewGame";
import { RetriggerControllerGame } from "../Retrigger/RetriggerController";
import { StackSymbolFeatureViewFG } from "../StackFeatureFG/StackSymbolFeatureViewFG";
import { StackSymbolFeatureControllerFG } from "../StackFeatureFG/StackSymbolFeatureControllerFG";
import { MagicPotionFeatureViewFG } from "../MagicPotionFreeGame/MagicPotionFeatureViewFG";
import { MagicPotionFeatureControllerFG } from "../MagicPotionFreeGame/MagicPotionFeatureControllerFG";
import { TopLogoViewGameFG } from "../TopLogo/TopLogoViewGameFG";

export class FreeGameStateAT extends FreeGameState {
  protected view: View;

  //Retrigger view & Controller variables
  protected retriggerView: RetriggerViewGame;
  protected retriggerController: RetriggerControllerGame;

  //Stack feature variables
  private stackSymbolViewFG: StackSymbolFeatureViewFG;
  private stackSymbolControllerFG: StackSymbolFeatureControllerFG;

  //Freegame magic potion feature variables
  private magicPotionFeatureViewFG: MagicPotionFeatureViewFG;
  protected magicPotionFeatureControllerFG: MagicPotionFeatureControllerFG;

  /**
   * Method overrided to initialize magic potion feature 
   */
  public init(): void {
    super.init();
    this.initializeMagicPotionFeature();
  }

  /**
   * Method overrided to subscribe game specific events
   */
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.INITIALIZE_FREEGAME_STACK_FEATURE, this.initializeStackSymbolFeatureFG, this);
  }

  /**
   * Method overrided to unsubscribe game specific events
   */
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.INITIALIZE_FREEGAME_STACK_FEATURE, this.initializeStackSymbolFeatureFG, this);
  }

  // Intialize stack symbol
  private initializeStackSymbolFeatureFG(): void {
    if (!this.stackSymbolViewFG) {
      this.stackSymbolViewFG = new StackSymbolFeatureViewFG(ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).stackSymFG);
      this.stackSymbolControllerFG = new StackSymbolFeatureControllerFG(this.stackSymbolViewFG);
      this.setLayering(this.stackSymbolViewFG, true);
    }
  }

  /**
   * This method is use to initialize magic potion feature
   */
  private initializeMagicPotionFeature(): void {
    this.magicPotionFeatureViewFG = new MagicPotionFeatureViewFG(ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).magicPotionFG);
    this.magicPotionFeatureControllerFG = new MagicPotionFeatureControllerFG(this.magicPotionFeatureViewFG);
    this.setLayering(this.magicPotionFeatureViewFG, false);
  }

  /**
   * Method overrided to destroy game specific features
   */
  public shutdown(): void {
    this.retriggerView && this.retriggerView.destroy();
    this.retriggerView = null;
    this.retriggerController && this.retriggerController.reset();
    this.retriggerController = null;
    this.stackSymbolViewFG && this.stackSymbolViewFG.destroy();
    this.stackSymbolViewFG = null;
    this.stackSymbolControllerFG && this.stackSymbolControllerFG.reset();
    this.stackSymbolControllerFG = null;
    super.shutdown();
  }

  /**
   * This method is use to initialize retrigger feature
   */
  protected initializeRetrigger(): void {
    if (!this.retriggerView) {
      this.retriggerView = new RetriggerViewGame(ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).reTrigger);
      this.retriggerController = new RetriggerControllerGame(this.retriggerView, this.view);
      ingenuity.currentGame.stage.addChildAt(this.retriggerView, ingenuity.currentGame.stage.children.length - 2);
    }
    dispatcher.fireEvent(eventDispatchers.START_RETRIGGER_PRESENTATION);
  }

  //set layering below winboxes
  private setLayering(obj: any, isStack: boolean) {
    const winBoxIndex: number = this.getWinBoxIndex(isStack);
    winBoxIndex && this.winReelpanel.addChildAt(obj, winBoxIndex);
  }

  //to get winBox Container Index
  //If "isStack" is true, then it will get view by index and will directly return the index of it
  private getWinBoxIndex(isStack: boolean): number {
    let winBoxContainer: number | DisplayObject;
    //If it is a stack, then get the magic potion view index so that we can add the stach view below to it
    if (isStack) {
      winBoxContainer = this.winReelpanel.getChildIndex(this.magicPotionFeatureViewFG);
    } else {
      winBoxContainer = this.winReelpanel.getChildByName("winboxContainer");
    }
    //If it is a stack, then return the index of magic pot view so that we can add stack feature add below to pot view
    if (winBoxContainer && isStack) {
      return winBoxContainer as number;
    } else {
      return this.winReelpanel.getChildIndex(winBoxContainer as DisplayObject);
    }
  }

  // Overrided to initialize top logo 
  protected initializeGameLogoView(): void {
    if (!this.topLogoView) {
      this.topLogoView = new TopLogoViewGameFG(ingenuity.assetsData.getJSONById(SlotConstantsBehavior.MAIN_DATA).topLogo, this.view);
      this.topLogoController = new TopLogoControllerFg(this.topLogoView);
    }
    else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_TOP_GAME_LOGO_FG);
    }
  }
}
